<template>
<div id="faq"> 
           <span class="Maintitle"> 
            <i class="fas fa-clinic-medical"></i>
            <strong> Limited Access Exception Drug Status (EDS) Application </strong> 
       </span> 
       <span class=""> 
        <h4><small class="text-muted">
                <i class="far fa-question-circle"></i>
                <strong> Frequently Asked Questions : </strong> 
        </small></h4>  
        </span> 
<div class="ml-0">
<hr>
<div v-b-toggle.collapse-1 class="card-title pointer row  ml-1 mr-1 Maintitle">
     <kbd>1</kbd><span ><strong>Community</strong></span>
</div> 
<!--Commenting out all Community Links Sans the Mmore Information will be posted card for HDP4631-->
<!-- <b-collapse visible id="collapse-1" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application User Guide June 3 2024.pdf')">
        a) Limited Access Exception Drug Status (EDS) Application User Guide June 3 2024</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application Q and A June 3 2024.pdf')">
        b) Limited Access Exception Drug Status (EDS) Application Q and A June 3 2024</a></b-card>    -->
    <!-- <b-card>*More information will be posted under Bulletins as it becomes available</b-card> -->
<!-- </b-collapse>
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Paxlovid Prescription for LAEA May 30 2024.pdf')">
        c) Prescription for Limited Access EDS Application</a></b-card>   
</b-collapse> -->
<!--Adding new Community links for HDP4631-->
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
  <b-card><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('LAEA Authorized User Application Community Pharmacy Pilot.pdf')">
      a) LAEA Authorized User Application Community Pharmacy Pilot</a></b-card>
</b-collapse>
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
  <b-card><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Policy and Procedures Limited Access Exception Drug Status Application (LAEA) August 1 2026.pdf')">
      b) Policy and Procedure LAEA August 1 2026</a></b-card>
</b-collapse>
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
  <b-card><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application Community Pharmacy User Guide August 1 2026.pdf')">
      c) LAEA Community Pharmacy User Guide August 1 2026</a></b-card>
</b-collapse>
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
  <b-card><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application Community Pharmacy Pilots Q and A August 1 2026.pdf')">
      d) LAEA Community Pharmacy Q and A August 1 2026</a></b-card>
</b-collapse>
<b-collapse visible id="collapse-1" class="mb-2 ml-1">
  <b-card><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access EDS Application Drug and Criteria List Community Pharmacy August 1 2026.pdf')">
      e) LAEA Drug and Criteria List Community Pharmacy August 1 2026</a></b-card>
</b-collapse>
<!--End HDP4631 Additions-->
<hr>
<div v-b-toggle.collapse-2 class="card-title pointer row  ml-1 mr-1 Maintitle">
     <kbd>2</kbd><span ><strong>Saskatchewan MS Drugs Program</strong></span>
</div> 
<b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('LAEA Authorized User Application.pdf')">
      a) LAEA Authorized User Application</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('LAEA MSDP Drug List July 2024.pdf')">
      b) LAEA MSDP Drug List July 2024</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('LAEA MSDP Peg_Interferon Chart July 2024.pdf')">
      c) LAEA MSDP Peg_Interferon Chart July 2024</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Saskatchewan MS Drugs Program LAEA Standard Work July 2024 v3.pdf')">
      d) Saskatchewan MS Drugs Program LAEA Standard Work July 2024 v3</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application MSDP July 2024 User Guide v3.pdf')">
      e) Limited Access Exception Drug Status (EDS) Application MSDP July 2024 User Guide v3</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-2" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application MSDP Q and A July 2024 v3.pdf')">
      f) Limited Access Exception Drug Status (EDS) Application MSDP Q and A July 2024 v3</a></b-card>   
</b-collapse>

<hr>
<div v-b-toggle.collapse-3 class="card-title pointer row  ml-1 mr-1 Maintitle">
     <kbd>3</kbd><span ><strong>SHA Pharmacy Department</strong></span>
</div> 
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('LAEA Authorized User Application.pdf')">
      a) LAEA Authorized User Application</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <!-- <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('SHA Pharmacy Department LAEA Standard Work Dec 2 2025.pdf')">
      b) SHA Pharmacy Department LAEA Standard Work Dec 2 2025</a></b-card> -->
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('SHA Pharmacy Department LAEA Standard Work August 1 2026.pdf')">
      b) SHA Pharmacy Department LAEA Standard Work August 1 2026</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('SHA Primary Health Care Pharmacy Department LAEA Standard Work Nov 17 2024.pdf')">
      c) SHA Primary Health Care Pharmacy Department LAEA Standard Work Nov 17 2024</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('SHA Outpatient Pharmacy Services LAEA Standard Work Jan 28 2025.pdf')">
      d) SHA Outpatient Pharmacy Services LAEA Standard Work Jan 28 2025</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <!-- <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application SHA Pharmacy September 17 2024 User Guide.pdf')">
      e) Limited Access EDS Application SHA Pharmacy Sept 17 2024 User Guide</a></b-card> -->
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application SHA Pharmacy User Guide August 1 2026.pdf')">
      e) Limited Access EDS Application SHA Pharmacy August 1 2026 User Guide</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <!-- <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application SHA Pharmacy Q and A September 17 2024.pdf')">
      f) Limited Access EDS Application SHA Pharmacy Q and A Sept 17 2024</a></b-card> -->
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Limited Access Exception Drug Status (EDS) Application SHA Pharmacy Q and August 1 2026.pdf')">
      f) Limited Access EDS Application SHA Pharmacy Q and A August 1 2026</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('SHA LAEA DRUG LIST February 1 2025.pdf')">
      g) SHA LAEA DRUG LIST February 1 2025</a></b-card>   
</b-collapse>
<b-collapse visible id="collapse-3" class="mb-2 ml-1">
    <b-card ><a class='pointer' style="text-decoration:underline" v-on:click="DownloadFile('Reminders and Drugs with Age Restrictions and Comments Sept 17 2024.pdf')">
      h) Reminders and Drugs with Age Restrictions and Comments Sept 17 2024</a></b-card>   
</b-collapse>
 
</div> 
</div>
</template>
<script> 
 import axios from "axios";
 import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import Subtitle from '@/Common/Default/SubTitle.vue'; 
import Accordion from '@/Common/Default/Accordion.vue'; 

export default  {
     props:{
        
     },  
  data: function () {
      
    return {
 	         text: ''
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote,
            Subtitle ,
            Accordion           
        },
    mounted: function () {
    this.$nextTick(function () {  
    })
    },
    created: function() { 
       // this.$emit('update:layout', FaqLayout);
        ////console.log('at Dental Main home')
        //this.menuitems = this.$store.getters.GetMainMenu; 
    },
    computed:{  
    },
    watch: { 
    },
    methods: {
     DownloadFile: function (filename) {
      var vm = this;
      // var filename = "Limited Access Exception Drug Status (EDS) Application Q and A June 3 2024.pdf";
      var url = "/SaskHealthApi/Codes/GetUserGuide?_=";
      var params = new URLSearchParams();   
      params.append("fileName", filename);
      axios
        .get(url + Date.now(), {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
          responseType: 'blob' ,
        })
        .then(function (response) {
        if (typeof window.chrome !== 'undefined') { 
            const pdfBlob = new Blob([response.data], { type: "application/pdf" }) 
            const blobUrl = window.URL.createObjectURL(pdfBlob)
            const link = document.createElement('a')
            link.href = blobUrl
            link.setAttribute('download', filename)
            link.click();
            link.remove();
            URL.revokeObjectURL(blobUrl); 
   
        } else if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE version
            var blob = new Blob([response.data], { type: 'application/pdf' });
            window.navigator.msSaveBlob(blob, filename);
        } else {
            // Firefox version
            var file = new File([response.data], filename, { type: 'application/force-download' });
            window.open(URL.createObjectURL(file));
        }
       })
        .catch(function (er) {
          if (er.response.status == 404) {
            ////console.log("at 404");
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          } else if (er.response.status == 400) {
            vm.showMsg(
              "File not found, please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          } else if (er.response.status == 500) {
            vm.showMsg(
              "Network Error: Please contact system admin for more detail.",
              "",
              "User Guide File Error"
            );
          }
          ////console.log(er);
        });
    },
          
    HideMsg: function(val){
 
        },
    showMsg1(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'primary',          
        okTitle: 'Close', 
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true, 
        }); 
      }, 
    },
}
</script>
<style scoped>
 
</style>

